import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { verifyEmailToken } from "@services/httpservice"; // Import the new service

const EmailVerification = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        // Use the service function
        await verifyEmailToken(token);
        setStatus('success');
        setMessage('Email verified successfully! You can now log in.');
        // Optionally redirect to login page after a few seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (error) {
        setStatus('error');
        // The error from fetchData should have a 'message' property
        setMessage(error.message || 'Failed to verify email. Please try again.');
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Email Verification
          </h2>
        </div>
        <div className="mt-8 space-y-6">
          {status === 'verifying' && (
            <div className="text-center">
              <p className="text-gray-600">Verifying your email...</p>
            </div>
          )}
          {status === 'success' && (
            <div className="text-center">
              <p className="text-green-600">{message}</p>
            </div>
          )}
          {status === 'error' && (
            <div className="text-center">
              <p className="text-red-600">{message}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;